import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Toaster } from 'sonner';
import '@/App.css';

import { AuthProvider } from './context/AuthContext';
import HomePage from './pages/HomePage';
import JulieOptionsPage from './pages/JulieOptionsPage';
import TeachingJulieOnlinePage from './pages/TeachingJulieOnlinePage';
import TeachingJulieGrevenPage from './pages/TeachingJulieGrevenPage';
import WeekendCoursePage from './pages/WeekendCoursePage';
import WeekendKursGrevenPage from './pages/WeekendKursGrevenPage';
import WeekendKursExternalPage from './pages/WeekendKursExternalPage';
import TheorieClinicPage from './pages/TheorieClinicPage';
import TeachingOscarPage from './pages/TeachingOscarPage';
import BookingSuccessPage from './pages/BookingSuccessPage';
import BookingCancelPage from './pages/BookingCancelPage';
import SignupPage from './pages/SignupPage';
import LoginPage from './pages/LoginPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import DashboardPage from './pages/DashboardPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import AdminCalendarPage from './pages/AdminCalendarPage';
import AdminBookingsPage from './pages/AdminBookingsPage';
import AdminAvailabilityPage from './pages/AdminAvailabilityPage';
import AdminWeekendCoursesPage from './pages/AdminWeekendCoursesPage';
import AdminUsersPage from './pages/AdminUsersPage';
import AdminServicesPage from './pages/AdminServicesPage';
import AdminBackupPage from './pages/AdminBackupPage';
import AdminJCPPage from './pages/AdminJCPPage';
import AdminNotesPage from './pages/AdminNotesPage';
import CustomerNotesPage from './pages/CustomerNotesPage';
import CustomerLessonNotesPage from './pages/CustomerLessonNotesPage';
import VocabularyPage from './pages/VocabularyPage';
import AvailabilityCreatePage from './pages/AvailabilityCreatePage';
import AvailabilityEditPage from './pages/AvailabilityEditPage';
import ChatWidget from './components/ChatWidget';

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/julie-options" element={<JulieOptionsPage />} />
            <Route path="/teaching-julie/online" element={<TeachingJulieOnlinePage />} />
            <Route path="/teaching-julie/greven" element={<TeachingJulieGrevenPage />} />
            <Route path="/weekend-course" element={<WeekendCoursePage />} />
            <Route path="/weekend-course-greven" element={<WeekendKursGrevenPage />} />
            <Route path="/weekend-course-external" element={<WeekendKursExternalPage />} />
            <Route path="/theorie-clinic" element={<TheorieClinicPage />} />
            <Route path="/teaching-oscar" element={<TeachingOscarPage />} />
            <Route path="/booking-success" element={<BookingSuccessPage />} />
            <Route path="/booking-cancel" element={<BookingCancelPage />} />
            
            {/* Auth routes */}
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/verify-email" element={<VerifyEmailPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            
            {/* Admin routes */}
            <Route path="/admin" element={<AdminDashboardPage />} />
            <Route path="/admin/calendar" element={<AdminCalendarPage />} />
            <Route path="/admin/bookings" element={<AdminBookingsPage />} />
            <Route path="/admin/availability" element={<AdminAvailabilityPage />} />
            <Route path="/admin/weekend-courses" element={<AdminWeekendCoursesPage />} />
            <Route path="/admin/users" element={<AdminUsersPage />} />
            <Route path="/admin/services" element={<AdminServicesPage />} />
            <Route path="/admin/backup" element={<AdminBackupPage />} />
            <Route path="/admin/jcp" element={<AdminJCPPage />} />
            <Route path="/admin/jcp/customer/:customerId/notes" element={<CustomerLessonNotesPage />} />
            
            {/* Notes routes - New dedicated section */}
            <Route path="/admin/noter" element={<AdminNotesPage />} />
            <Route path="/admin/noter/:customerId" element={<CustomerNotesPage />} />
            <Route path="/admin/noter/:customerId/hest/:horseId" element={<CustomerLessonNotesPage />} />
            <Route path="/admin/ordliste" element={<VocabularyPage />} />
            
            <Route path="/admin/availability/create" element={<AvailabilityCreatePage />} />
            <Route path="/admin/availability/edit/:instructorId/:date" element={<AvailabilityEditPage />} />
          </Routes>
          <ChatWidget />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
